import React, { useState } from "react";
import {
  PageHeader,
  Upload,
  Button,
  Icon,
  notification,
  DatePicker,
} from "antd";
import {
  uploadTemplateApiIVA,
  downloadTemplateApiIVA,
  uploadTemplateApiICA,
  downloadTemplateApiICA,
  uploadTemplateApiFuente,
  downloadTemplateApiFuente,
} from "../../../api/supplier";
import { getAccesTokenApi } from "../../../api/auth";

import "./UploadCertificates.scss";

export default function UploadCertificates() {
  const [fileList, setFileList] = useState([]);
  const [fileListICA, setFileListICA] = useState([]);
  const [fileListFuente, setFileListFuente] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [uploadingICA, setUploadingICA] = useState(false);
  const [downloadingICA, setDownloadingICA] = useState(false);
  const [uploadingFuente, setUploadingFuente] = useState(false);
  const [downloadingFuente, setDownloadingFuente] = useState(false);
  const [dateFuente, setDateFuente] = useState("");
  const token = getAccesTokenApi();

  const handleUploadIVA = () => {
    setUploading(true);

    uploadTemplateApiIVA(token, fileList).then((response) => {
      if (response === "OK") {
        notification["success"]({
          message: "Plantilla de retención de IVA cargado Satisfactoriamente",
        });
      } else {
        notification["error"]({
          message: "Error cargando archivo: " + response,
        });
      }
      setFileList([]);
      setUploading(false);
    });
  };

  const downloadTempIVA = () => {
    setDownloading(true);

    downloadTemplateApiIVA().then((response) => {
      if (response === "OK") {
        notification["success"]({
          message: "Plantilla de IVA descargada Satisfactoriamente",
        });
      } else {
        notification["error"]({
          message: "Error descargando plantilla",
        });
      }
      setDownloading(false);
    });
  };

  const propertiesIVA = {
    onRemove: (file) => {
      /*const index = fileList.indexOf(file);
			const newFileList = fileList.slice();
			newFileList.splice(index, 1);
			fileList = newFileList;*/
      setFileList([]);
    },
    beforeUpload: (file) => {
      if (
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setFileList([...fileList, file]);
        return false;
      } else {
        setFileList([]);
        notification["error"]({
          message: "Solo se permitem plantillas en formato de Excel (XLSX)",
        });
      }
    },
    fileList,
  };

  const handleUploadICA = () => {
    setUploadingICA(true);

    uploadTemplateApiICA(token, fileListICA).then((response) => {
      if (response === "OK") {
        notification["success"]({
          message: "Plantilla de retención de ICA cargado Satisfactoriamente",
        });
      } else {
        notification["error"]({
          message: "Error cargando archivo: " + response,
        });
      }
      setFileListICA([]);
      setUploadingICA(false);
    });
  };

  const downloadTempICA = () => {
    setDownloadingICA(true);

    downloadTemplateApiICA().then((response) => {
      if (response === "OK") {
        notification["success"]({
          message: "Plantilla de ICA descargada Satisfactoriamente",
        });
      } else {
        notification["error"]({
          message: "Error descargando plantilla",
        });
      }
      setDownloadingICA(false);
    });
  };

  const propertiesICA = {
    onRemove: (fileICA) => {
      setFileListICA([]);
    },
    beforeUpload: (fileICA) => {
      if (
        fileICA.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setFileListICA([...fileListICA, fileICA]);
        return false;
      } else {
        setFileListICA([]);
        notification["error"]({
          message: "Solo se permitem plantillas en formato de Excel (XLSX)",
        });
      }
    },
    fileListICA,
  };

  const handleUploadFuente = () => {
    setUploadingFuente(true);
    console.log(dateFuente);
    uploadTemplateApiFuente(token, fileListFuente, dateFuente).then(
      (response) => {
        if (response === "OK") {
          notification["success"]({
            message:
              "Plantilla de retención de Renta cargado Satisfactoriamente",
          });
        } else {
          notification["error"]({
            message: "Error cargando archivo: " + response,
          });
        }
        setFileListFuente([]);
        setDateFuente();
        setUploadingFuente(false);
      }
    );
  };

  const downloadTempFuente = () => {
    setDownloadingFuente(true);

    downloadTemplateApiFuente().then((response) => {
      if (response === "OK") {
        notification["success"]({
          message: "Plantilla de Renta descargada Satisfactoriamente",
        });
      } else {
        notification["error"]({
          message: "Error descargando plantilla",
        });
      }
      setFileListFuente([]);
      setDownloadingFuente(false);
    });
  };

  const propertiesFuente = {
    onRemove: (fileFuente) => {
      setFileListFuente([]);
    },
    beforeUpload: (fileFuente) => {
      if (
        fileFuente.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        setFileListFuente([...fileListFuente, fileFuente]);
        return false;
      } else {
        setFileListFuente([]);
        notification["error"]({
          message: "Solo se permitem plantillas en formato de Excel (XLSX)",
        });
      }
    },
    fileListFuente,
  };

  return (
    
    <div className="upload-certificates">
      <iframe
        id="inlineFrameExample"
        title="Inline Frame Example"
        width="1500"
        height="1500"
        src="http://qa.icontec.org:8049/">
      </iframe>
  {/*
      <PageHeader
         title="Cargar plantilla"
        subTitle=" de Retencion de IVA"
      />
      {/*
      <Upload {...propertiesIVA}>
        <Button disabled={fileList.length === 1}>
          <Icon type="upload" /> Seleccione Plantilla
        </Button>
      </Upload>
      <Button
        type="primary"
        onClick={handleUploadIVA}
        disabled={fileList.length === 0}
        loading={uploading}
        style={{ marginTop: 16 }}
      >
        {uploading ? "Cargando plantilla..." : "Iniciar carga"}
      </Button>
      {/* 
      <PageHeader
     title="Cargar plantilla"
        subTitle=" de Retencion de ICA"
      />
      {/*
      <Upload {...propertiesICA}>
        <Button disabled={fileListICA.length === 1}>
          <Icon type="upload" /> Seleccione Plantilla
        </Button>
      </Upload>
      <Button
        type="primary"
        onClick={handleUploadICA}
        disabled={fileListICA.length === 0}
        loading={uploadingICA}
        style={{ marginTop: 16 }}
      >
        {uploadingICA ? "Cargando plantilla..." : "Iniciar carga"}
      </Button>
    {/* <PageHeader
      title="Cargar plantilla"
        subTitle=" de Retencion de Renta"
      />*/}
      
    
    {/* 
      <Upload {...propertiesFuente}>
        <Button disabled={fileListFuente.length === 1}>
          <Icon type="upload" /> Seleccione Plantilla
        </Button>
      </Upload>
      <DatePicker
        format="YYYY-MM-DD"
        placeholder="Fecha del Certificado"
        style={{ marginTop: 16, marginRight: 10 }}
        value={dateFuente}
        onChange={(e) => {
          setDateFuente(e);
        }}
      />
      {/* <Button
        type="primary"
        onClick={handleUploadFuente}
        disabled={fileListFuente.length === 0 || dateFuente === ""}
        loading={uploadingFuente}
        style={{ marginTop: 16 }}
      > */}
      
      {/* {uploadingFuente ? "Cargando plantilla..." : "Iniciar carga"}
      </Button>*/}
        
    
    </div>
  );
}
